webpackJsonp([246384609461072],{

/***/ "./src/assets/drone.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/drone.27f07bae.jpg";

/***/ }),

/***/ "./src/assets/eatxpress.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/eatxpress.8ecdf862.jpg";

/***/ }),

/***/ "./src/assets/ttc-complaints.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ttc-complaints.4c7e84eb.jpg";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dennis/dev/dkonieczek.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dennis/dev/dkonieczek.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dennis/dev/dkonieczek.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/dennis/dev/dkonieczek.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dennis/dev/dkonieczek.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dennis/dev/dkonieczek.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/portfolio.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ttcComplaints = __webpack_require__("./src/assets/ttc-complaints.jpg");
	
	var _ttcComplaints2 = _interopRequireDefault(_ttcComplaints);
	
	var _drone = __webpack_require__("./src/assets/drone.jpg");
	
	var _drone2 = _interopRequireDefault(_drone);
	
	var _eatxpress = __webpack_require__("./src/assets/eatxpress.jpg");
	
	var _eatxpress2 = _interopRequireDefault(_eatxpress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PortfolioPage = function PortfolioPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'portfolio' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Portfolio'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'item' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'TTC Complaints'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement('img', { src: _ttcComplaints2.default, alt: 'TTC Complaints' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'desc' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Single page application built using HTML, SASS, jQuery, Node, Express, MongoDB'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Allows a user to submit a complaint to a public Facebook like wall. Specifically, I built this with the intention to highlight some of the things people had to say about the TTC (Toronto Transit Commission)'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'item' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Micro Drone Flight Control'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement('img', { src: _drone2.default, alt: 'Micro Drone Flight Control' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'desc' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'IoT (Internet of Things) themed project built on the Arduino platform'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'This project modifies the Hubsan X4 micro drone so that it is able to be controlled with an android device and its accelerometer, instead of the default shipped controller.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'item' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'EatXpress'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement('img', { src: _eatxpress2.default, alt: 'EatXpress' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'desc' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'An android application designed to handle orders for a restaurant.'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = PortfolioPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portfolio-js-dbb788e1a2d17efc5285.js